import { lazy } from 'react';
import { authRoles } from 'auth/authRoles';
import Loadable from 'ui-component/Loadable';

const Nickel = Loadable(lazy(() => import('./Nickel')));
const Create = Loadable(lazy(() => import('./Create')));
const Update = Loadable(lazy(() => import('./Update')));
const View = Loadable(lazy(() => import('./View')));

const routeTypes = [
    { path: 'nickel', type: 'inward' },
    { path: 'nickel-outward', type: 'outward' }
];

const NickelRoutes = routeTypes.flatMap(({ path, type }) => [
    {
        path: `/${path}/create`,
        element: <Create type={type} />,
        auth: authRoles.admin
    },
    {
        path: `/${path}`,
        element: <Nickel type={type} />,
        auth: authRoles.admin
    },
    {
        path: `/${path}/edit/:id`,
        element: <Update type={type} />,
        auth: authRoles.admin
    },
    {
        path: `/${path}/view/:id`,
        element: <View type={type} />,
        auth: authRoles.admin
    }
]);

export default NickelRoutes;